/** @format */

import React, {
  ReactElement,
  PropsWithChildren,
  useEffect,
  useState,
} from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  isOneOfTheseFlagsTrue,
  loadFlags,
  selectStatus,
} from "./featureFlagSlice";

/**
 * The <FeatureFlag/> component is a simple wrapper for any content. It controls whether the content
 * is displayed or not based on whether any of the flags specified in the flag prop are in the Redux
 * state or not. If not, it will show the fallback content if set or null.
 *
 * e.g. <FeatureFlag flag={['dev','preview']} fallback={<>Fallback content</>}> Some content </FeatureFlag>
 * This will show "Some content" if either the dev or preview flag is present, otherwise it will show
 * "Fallback content".
 */
export interface FeatureFlagProps {
  flag: string | string[];
  fallback?: ReactElement;
}
const FeatureFlag: React.FC<PropsWithChildren<FeatureFlagProps>> = ({
  children,
  flag: flagName,
  fallback,
}) => {
  const [flags] = useState<string[]>(
    !Array.isArray(flagName) ? [flagName] : flagName,
  );
  const isFlagActive = useAppSelector(isOneOfTheseFlagsTrue(flags));
  const status = useAppSelector(selectStatus());
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (status === "notloaded") {
      dispatch(loadFlags());
    }
  }, [status, dispatch]);

  useEffect(() => {
    if (!isFlagActive) return;
    //console.log(`FLAGS ON: ${flags.join(', ')}`)
  }, [isFlagActive, flags]);

  return isFlagActive ? <>{children}</> : fallback || null;
};

export default FeatureFlag;
